import { NavLink } from 'react-router-dom';
import cn from '../../utils/classNames.js';

// Renders as a static column on lg+ and a slide-in drawer on < lg.
// Pass `open` + `onClose` from the parent layout to control the mobile state.
export default function Sidebar({ items = [], open = false, onClose }) {
  return (
    <>
      {/* Backdrop - only visible on mobile when open */}
      {open && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Close menu"
          className="fixed inset-0 z-30 bg-black/40 lg:hidden"
        />
      )}

      <aside
        className={cn(
          'fixed inset-y-0 left-0 z-40 w-64 max-w-[80vw] shrink-0 overflow-y-auto border-r border-white/10 bg-brand-600 text-slate-200 transition-transform duration-200',
          'lg:static lg:z-auto lg:w-60 lg:max-w-none lg:translate-x-0',
          open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        )}
        aria-hidden={!open && undefined}
      >
        <ul className="space-y-1 p-3 text-sm">
          {items.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end
                onClick={onClose}
                className={({ isActive }) =>
                  cn(
                    'block rounded-md px-3 py-2',
                    isActive
                      ? 'bg-brand-orange font-semibold text-brand-navy'
                      : 'text-slate-300 hover:bg-brand-500 hover:text-white'
                  )
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </aside>
    </>
  );
}
